function showUp(dom){
    gsap.from(dom, {
        y: '2rem', opacity: 0, ease: 'none', duration: 0.5,
        scrollTrigger: {
            trigger: dom,
            start: 'top bottom-=20%',
            end: '+=0',
            //toggleActions: 'play none none reverse',
        }
    })
}

function onViewLoad(className) {
    const elements = $(className).get();
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                const video = entry.target
                video.src = video.dataset.src
                video.load()
                observer.unobserve(video);
            }
        });
    }, { threshold:0,rootMargin: '500px', });
    
    elements.forEach(el => observer.observe(el));
}

function autoPlayOnView(className, threshold = 0.5) {
    const elements = $(className).get();
  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.play();
          observer.unobserve(entry.target); // 播放一次后取消观察
        }
      });
    }, { threshold });
  
    elements.forEach(el => observer.observe(el));
}

var wFlag = window.innerWidth > 750

onViewLoad('.lazy_video')
if(wFlag){
    onViewLoad('.lazy_video_p')
}else{
    onViewLoad('.lazy_video_m')
}


$(() => {
    setInterval(() => {
        if (wFlag) {
            $('.box1_title').css({ transform: 'translateY(0)', opacity: 1 })
        } else {
            $('.Mbox1_title').css({ transform: 'translateY(0)', opacity: 1 })
        }
    }, 300);

    //box1
    if(wFlag){
        ScrollTrigger.create({
            trigger: '.box1',
            start: 'top+=10% top',
            end: '+=200%',
            scrub: 1,
            animation: gsap.timeline()
                .to('.box1_mask', { scale: 1 })
                .to('.box1_mask', { background: 'black' }, '-=30%')
                .to('.box1m_text span', { opacity: 1, y: '0', stagger: 0.2 }, '-=20%')
                .to('.box1_specs', { opacity: 1 }, '<')
                .to('.box1m_text', { y: 0, scale: 1 })
                .to('.box1_mask', { opacity: 0 })
                .from('.box1_items .box1_item:nth-child(1)', { opacity: 0, x: '20%', y: '20%' })
                .from('.box1_items .box1_item:nth-child(2)', { opacity: 0, x: '-20%', y: '20%' }, '<')
                .from('.box1_items .box1_item:nth-child(3)', { opacity: 0, x: '20%', y: '-20%' }, '<')
                .from('.box1_items .box1_item:nth-child(4)', { opacity: 0, x: '-20%', y: '-20%' }, '<')
                .from('.box1_text', { opacity: 0, y: '2rem' })
        })

        ScrollTrigger.create({
            trigger: '.box1',
            start: 'top top',
            end: '+=240%',
            pin: true,
            anticipatePin: 1
        })
    }else{
        const items = gsap.utils.toArray('.Mbox1_text div');

        ScrollTrigger.create({
            trigger: '.Mbox1_text',
            start: 'top center+=10%',
            end: '+=60%',
            scrub: 1,
            toggleActions: 'play none none reverse',
            onUpdate(self) {
                const index = Math.min(
                    items.length - 1,
                    Math.floor(self.progress * items.length)
                );

                // 先全部恢复默认颜色
                gsap.set(items, { color: '#444' });

                // 当前这个变红
                gsap.set(items[index], { color: 'red' });
            },

            // 滚出范围后全部恢复默认颜色，可按需保留
            onLeaveBack() {
                gsap.set(items, { color: '#444' });
            }
        })
    }

    //box3
    showUp('.box3_title')
    var box3Swiper = new Swiper('.box3Swiper', {
        autoplay: true,
        effect: 'fade',
        loop:true,
        on:{
            slideChange: function(){
                var index = this.realIndex
                $('.box3_item img').eq(index).addClass('box3Active1').siblings().removeClass('box3Active1')
                $('.box3_icon div').eq(index).addClass('box3Active').siblings().removeClass('box3Active')
            }
        },
    })
    $('.box3_icon div').click(function(){
        box3Swiper.slideTo($(this).index()+1, 300);
    })
    $('.box3_item img').click(function(){
        box3Swiper.slideTo($(this).index()+1, 300);
    })

    //box2
    showUp('.box2_title')
    ScrollTrigger.create({
        trigger: '.box2',
        start: wFlag?'top center-=10%':'top center+=10%',
        end: '+=20%',
        scrub:1,
        animation: gsap.timeline()
            .from('.box2_bg', { opacity:0 })
    })
    showUp('.box2_icon')

    //box4
    showUp('.box4_title')
    ScrollTrigger.create({
        trigger: '.box4',
        start: wFlag?'top center':'top center+=10%',
        end: '+=20%',
        scrub:1, 
        animation: gsap.timeline()
            .from('.box4_bg', { opacity:0 })
            .from('.box4_text span', { opacity:0},'-=50%')
    })
    if(!wFlag){
        showUp('.Mbox4_text')
    }

    //box5
    ScrollTrigger.create({
        trigger: '.box5',
        start: wFlag?'top center':'top center+=10%',
        end: '+=20%',
        scrub:1, 
        animation: gsap.timeline()
            .from('.box5_title', { opacity:0 })
    })

    ScrollTrigger.create({
        trigger: '.box5',
        start: wFlag?'top top+=4%':'top top+=6%',
        end: '+=150%',
        scrub:1,
        pin:true,
        anticipatePin: 1,
        animation: gsap.timeline()
            .to('.box5_title span:last-child', { opacity:0 })
            .to('.box5_title', { x:wFlag?'89%':'0%',y:wFlag?'0%':'20%',scale:wFlag?1.8:1.2 },'-=20%')
            .from('.box5_img', { opacity:0,y:'5%' })
            .from('.box5_text', { opacity:0,y:'2%' })
            .from('.box5_img img:nth-child(2)', { opacity:0 })
            .from('.box5_img div', { opacity:0 },'<')
            .to({}, { duration:0.2 })
    })

    gsap.fromTo( '.box5_img div img',{ opacity: 0 },{opacity: 1,duration: 1,repeat: -1,yoyo: true,ease: 'none'});

    //box6
    showUp('.box6_title')
    ScrollTrigger.create({
        trigger: '.box6',
        start: wFlag?'top top+=4%':'top top+=6%',
        end: '+=40%',
        pin:true,
        anticipatePin: 1,
        onUpdate: function (self) {
            let index = Math.floor(self.progress * 10);
            $('.box6_left div:last-child').toggleClass('box6Active',index>4)
        }
    })

    //box7
    if(wFlag){
        var $video = $('.box7_video');
        ScrollTrigger.create({
            trigger:'.box7',
            start:'top center+=10%',
            end:'+=100%',
            scrub:true,
            onUpdate: function (self) {
                //console.log($video[0].duration)
                $video[0].currentTime = self.progress * 3.56;
                $('.box7_title').toggleClass('showUp',self.progress>0.8)
            },
            animation: gsap.timeline()
                .from('.box7_video', { opacity:0 })
                .to({}, { duration:0.5 })
        })

        ScrollTrigger.create({
            trigger:'.box7',
            start:'top top+=2%',
            end:'+=80%',
            pin:true,
            anticipatePin: 1
        })
    }else{
        showUp('.box7_title')
        autoPlayOnView('.box7_video')
    }

    //box8
    showUp('.box8_title')

    var nexlimN1 = 100,ng_flag=true,flag_ng;
    function startNG(){
        clearInterval(flag_ng); // 防止重复开启多个定时器
        flag_ng =  setInterval(num,15)
    }
    function num(){
        nexlimN1++;
        if (nexlimN1 >= 200) {
            nexlimN1 = 200;
            clearInterval(flag_ng);
        }
    
        $(`.box8_item div p c`).text(`${nexlimN1}%`);
    }

    ScrollTrigger.create({
        trigger:'.box8', 
        start:'top center',
        end:'+=0%',
        toggleActions:'play none none reverse',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(index>10){
                // 执行一次
                if(ng_flag){
                    startNG()
                    ng_flag=false;
                }
            }
            if(index<2){
                // 重置
                ng_flag=true,nexlimN1 = 100
            }
        }
    })

    //box10
    showUp('.box10_title')
    let box10Status = null;
    ScrollTrigger.create({
        trigger:'.box10', 
        start:wFlag?'top top+=2%':'top top+=6%',
        end:'+=50%',
        pin:true,
        anticipatePin: 1,
        onUpdate: (self) => {
            let stage = 0;
    
            if (self.progress >= 0.6) {
                stage = 2;
            } else if (self.progress >= 0.3) {
                stage = 1;
            } else {
                stage = 0;
            }
    
            // 阶段没变化，不重复执行
            if (stage === box10Status) return;
    
            box10Status = stage;
    
            // 三个阶段对应的位置
            const xArr = wFlag?[18, -17, -50]:[0, -33.3, -66.6];
            $('.box10_items').css({transform:`translate(${xArr[stage]}%)`})
            $('.box10_item').removeClass('box10Active').eq(stage).addClass('box10Active');
        }
    })

    //box9
    showUp('.box9_title')

    //box11
    showUp('.box11_title')
    ScrollTrigger.create({
        trigger: '.box11',
        start: wFlag?'top top+=10%':'top top+=20%',
        end: '+=0%',
        toggleActions:'play none none reverse',
        onUpdate: function (self) {
            let index = Math.floor(self.progress * 10);
            $('.box11_icon').toggleClass('box11Active',index>4)
        }
    })

    //box12
    showUp('.box12_title')

    //box13
    showUp('.box13_title')

    //move img
    const box13Imgs = gsap.utils.toArray('.box13_img img');

    const startX = 140;
    const gap = 120;
    const move = startX + gap * (box13Imgs.length - 1);

    const state = { progress: 0 };

    gsap.set(box13Imgs, {
        xPercent: i => startX + i * gap
    });

    function updateBox13Imgs() {
        const currentMove = move * state.progress;

        box13Imgs.forEach((img, i) => {
            const x = startX + i * gap - currentMove;

            gsap.set(img, {
                xPercent: Math.max(0, x)
            });
        });
    }

    ScrollTrigger.create({
        trigger: '.box13',
        start: wFlag ? 'top top+=4%' : 'top top+=6%',
        end: '+=220%',
        pin: true,
        scrub: 1,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        animation: gsap.timeline()
            .to(state, {
                progress: 1,
                ease: 'none',
                duration: 1,
                onUpdate: updateBox13Imgs
            })
            .to({}, {duration:0.2})
    });

    //box14
    showUp('.box14_title')

    //box15
    showUp('.box15_title')

    //box16
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box16',
            start:'top top+=2%',
            end:'+=60%',
            pin:true,
            scrub:1,
            anticipatePin: 1,
            //toggleActions: 'play none none reverse',
            animation:gsap.timeline()
                .to({},{duration:0.2})
                .from('.box16_img',{y:'-16%',scale:2})
                .from('.box16_title',{opacity:0})
                .from('.box16_text',{opacity:0},'<')
                .to({},{duration:0.2})
        })
    }

    //box17
    showUp('.box17_title')

    //box19
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box19',
            start:'top center+=10%',
            end:'+=60%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box19_item div:nth-child(1)',{x:'-95%'})
                .from('.box19_item div:nth-child(2)',{x:'90%'},'<')
                .from('.box19_item div:nth-child(3)',{x:'-85%'},'<')
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box19',
            start:'top top+=6%',
            end:'+=80%',
            scrub:1,
            pin:true,
            anticipatePin: 1,
            animation:gsap.timeline()
                .from('.box19_item div:nth-child(2)',{y:'2rem',opacity:0})
                .to('.box19_item div:nth-child(1)',{y:'-3rem',scale:0.85},'<')
                .to('.box19_item div:nth-child(1) p',{opacity:0},'<')
                .from('.box19_item div:nth-child(3)',{y:'2rem',opacity:0})
                .to('.box19_item div:nth-child(2)',{y:'-1.2rem',scale:0.95},'<')
                .to('.box19_item div:nth-child(2) p',{opacity:0},'<')
        })
    }

    //box9_1
    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })
})

 
//boxSpecs_btn
$('.bs_btn').click(function(){
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_buy').click(function(){ 
    window.open('https://store.oxva.com/products/oxva-nexlim-2'); 
})

$('.pnr_spec').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_over2').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section2').hide()
    $('.classic_section1').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
})
     
// DOM 准备好后初始化
document.addEventListener("DOMContentLoaded", () => {
    initTornado();
});

function initTornado(wrapperSelector = ".tornado_wrapper") {
    const wrapper = document.querySelector(wrapperSelector);
    if (!wrapper) return;
    const list  = wrapper.querySelector(".tornado_list");
    const cards = wrapper.querySelectorAll(".tornado_item");
    const pics  = wrapper.querySelectorAll(".teammate_pic");
    
    if (!cards.length) return;
    
    // 给头像略微上下错位（-25 / 0 / 25 循环）
    gsap.set(pics, {
        yPercent: i => gsap.utils.wrap([-25, 0, 25], i)
    });
    // gsap.set(cards, {
    //     rotateZ: i => gsap.utils.wrap([-8, -4, 0, 4, 8], i)
    // });
    
    // 设置每个 item 的 transform-origin（圆柱半径）
    function setTransformOrigin() {
        // 调整宽度
        //const radius = -window.innerWidth * itemWidth; // 和原站类似
        const radius = -window.innerWidth * (wFlag?0.25:0.6);
        gsap.set(cards, {
            transformOrigin: `50% 50% ${radius}px`
        });
    }
    setTransformOrigin();
    
    // 无限旋转时间轴（只有旋转，没有进场）
    const spinTl = gsap.timeline({
        paused: true,         // 默认暂停，滚动到视口再播放
        repeat: -1,
        defaults: {
            ease: "none",
            duration: 30        // 一圈时长，可自行调
        }
    });
    
    // 均匀分布到 360° 上，然后整体 -=360 做无限旋转
    spinTl.fromTo(
    cards,
    {
        rotationY: i => (i * 360) / cards.length
    },
    {
        rotationY: "-=360"
    }
    );
    
    //spinTl.play();
    // ScrollTrigger 控制何时转、何时停
    ScrollTrigger.create({
        trigger: wrapper,
        start: "top bottom",
        end: "+=99999", // 永远有效
        onEnter: () => spinTl.play(),
        // scrub: true,
        // invalidateOnRefresh: true,
        
        onToggle: self => {
            if (self.isActive) {
                spinTl.play();
            } else {
                spinTl.pause();
            }
        },
        
        onRefresh: () => {
            // resize 后重算 3D 场景
            setTransformOrigin();
            gsap.set(pics, {
                yPercent: i => gsap.utils.wrap([-25, 0, 25], i)
            });
        }
    });
    
    ScrollTrigger.refresh();
}